const isVisibleToggle = (visible, hidden) => (props) => {
  if (props.isVisible) {
    return visible;
  }

  return hidden;
};

export default isVisibleToggle;
